import dayjs from 'dayjs';
import { SearhApiInputResolver } from "./SearhApiInputResolver";
import { IDocUrlKeyNamePair } from "../../../../interfaces/IDocUrlKeyNamePair";
import { SearhApiInputEnum } from "../../../enums/SearhApiInputEnum";
import { IDocumentSearchField } from "../../../../interfaces/advancedSearch/IDocumentSearchField";
import { IDocumentSearchRequest } from "../../../../interfaces/advancedSearch/IDocumentSearchRequest";
import { ISharepointSearchInput } from "../../../../interfaces/advancedSearch/ISharepointSearchInput";
import { InputTypeFactory } from './inputTypeFactory';
import advancedSearchStateManager from '../../../../../../advancedSearch/advancedSearchStateManager';
import { InputEnum } from '../../../enums/NormalInputTypeEnum';
import { SharePointInputTypes } from '../../../../config/sharepointConstants';

export class DocumentSearchRequestBuilder {
  build(doclibrary: IDocUrlKeyNamePair, fields: ISharepointSearchInput[], accessToken: string): IDocumentSearchRequest {
    return {
      accessToken: accessToken,
      documentLibraryTitle: doclibrary.documentLibrary,
      siteId: doclibrary.siteId,
      siteWebUrl: doclibrary.webUrl,
      searchFields: this.buildSearchFields(fields)
    };
  }

  private buildSearchFields = (fields: ISharepointSearchInput[]): IDocumentSearchField[] => {
    const inputTypeFactory = new InputTypeFactory();
    return fields.map(item => {
      const inputType: InputEnum = item.xml && inputTypeFactory.getInputType(item.xml, advancedSearchStateManager.datasourceFields ?? []);
      let fieldSearchType: string;
      if (inputType === InputEnum.datasourceMultipleDropdown) {
        fieldSearchType = SharePointInputTypes.multiChoice;
      }
      else if (item.type.toLowerCase().includes("calculated")) {
        fieldSearchType = item.xml.ResultType;
      }
      else {
        fieldSearchType = item.type;
      }

      const type = SearhApiInputResolver.resolveSharepointTypeToApiEnumType(fieldSearchType);

      return {
        type: SearhApiInputResolver.getApiType(type),
        name: item.internalName,
        value: this.buildValue(item.type.toLowerCase().includes("percentage") ? item.value / 100 : item.value, type)
      };
    });
  };

  private buildValue(value, type: SearhApiInputEnum) {
    return Array.isArray(value) ? this.buildArrayValues(value, type) : value.toString();
  }

  private buildArrayValues = (value: any[], type: SearhApiInputEnum) => {
    return type === SearhApiInputEnum.dateTime
      ? value.map(item => item && dayjs(item).toISOString()).join(";")
      : value.join(";");
  };
}
